module.exports = __webpack_public_path__ + "static/img/Embossing PU Processing4.524df276.jpg";